export default __webpack_public_path__ + "static/media/My project (83) 1.1cef2ec4.png";